import { SVGProps } from 'react';

const PersonIcon: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 16C13.1867 16 14.3467 15.6481 15.3334 14.9888C16.3201 14.3295 17.0892 13.3925 17.5433 12.2961C17.9974 11.1997 18.1162 9.99335 17.8847 8.82946C17.6532 7.66558 17.0818 6.59648 16.2426 5.75736C15.4035 4.91825 14.3344 4.3468 13.1705 4.11529C12.0067 3.88378 10.8003 4.0026 9.7039 4.45673C8.60754 4.91085 7.67047 5.67989 7.01118 6.66658C6.35189 7.65328 6 8.81331 6 10C6.00159 11.5908 6.63424 13.116 7.75911 14.2409C8.88399 15.3658 10.4092 15.9984 12 16ZM12 6C12.7911 6 13.5645 6.2346 14.2223 6.67412C14.8801 7.11365 15.3928 7.73836 15.6955 8.46927C15.9983 9.20017 16.0775 10.0044 15.9231 10.7804C15.7688 11.5563 15.3878 12.269 14.8284 12.8284C14.269 13.3878 13.5563 13.7688 12.7804 13.9231C12.0044 14.0775 11.2002 13.9983 10.4693 13.6955C9.73836 13.3928 9.11365 12.8801 8.67412 12.2223C8.2346 11.5645 8 10.7911 8 10C8 8.93914 8.42143 7.92172 9.17157 7.17158C9.92172 6.42143 10.9391 6 12 6Z"
      fill="#7C69FF"
    />
    <path
      d="M12 18C9.61386 18.0026 7.32622 18.9517 5.63896 20.639C3.95171 22.3262 3.00265 24.6139 3 27C3 27.2652 3.10536 27.5196 3.29289 27.7071C3.48043 27.8946 3.73478 28 4 28C4.26522 28 4.51957 27.8946 4.70711 27.7071C4.89464 27.5196 5 27.2652 5 27C5 25.1435 5.7375 23.363 7.05025 22.0503C8.36301 20.7375 10.1435 20 12 20C13.8565 20 15.637 20.7375 16.9497 22.0503C18.2625 23.363 19 25.1435 19 27C19 27.2652 19.1054 27.5196 19.2929 27.7071C19.4804 27.8946 19.7348 28 20 28C20.2652 28 20.5196 27.8946 20.7071 27.7071C20.8946 27.5196 21 27.2652 21 27C20.9974 24.6139 20.0483 22.3262 18.361 20.639C16.6738 18.9517 14.3861 18.0026 12 18Z"
      fill="#7C69FF"
    />
  </svg>
);

export default PersonIcon;
